// Mein Schuster brand marks (both transparent PNGs).
// - header: kompakte Variante ohne Untertitel (für Navbar)
// - full:   komplette Version mit "Schuhreparatur & Schlüsseldienst" (für Hero)

const LOGO_HEADER = "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/r5lyn62s_Meinschuster%20oben%20links%20header.png";
const LOGO_FULL = "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/u0fcnlac_IMG_0894-removebg-preview.png";

export default function Logo({ className = "", size = "md", variant = "full" }) {
    const imgHeights = {
        sm: "h-10",
        md: "h-16",
        lg: "h-20",
        xl: "h-24",
        "2xl": "h-40 md:h-52",
    };

    const src = variant === "header" ? LOGO_HEADER : LOGO_FULL;

    return (
        <img
            src={src}
            alt="Mein Schuster – Schuhreparatur & Schlüsseldienst"
            data-testid="brand-logo"
            className={`${imgHeights[size] || imgHeights.md} w-auto object-contain select-none ${className}`}
            draggable={false}
        />
    );
}
